const clientEvent = kf.require('basic.clientEvent');
// 每个界面的基础类
const panel = kf.require('component.panel');
// const code = kf.require('shared.code');
const constants = require('constants');
const pool = kf.require('basic.pool');
const localConfig = require('localConfig');
const playerData = require('playerData');
const resourceUtil = require('resourceUtil');
const HttpUtil = require("HttpUtil");

const shopPanelObj = cc.Class({
    // 每个界面要注意继承panel
    extends: panel,

    properties: {
        shopItemPrefab: cc.Prefab,
        nodeShopPage: cc.Node,
        nodeShopContent: cc.Node,
        nodeMoney: cc.EditBox,
        goldLab: cc.Label,
    },

    // use this for initialization
    onLoad() {
        // 要注意调用 super,使panel中的框架代码生效
        this._super();

        // 固定函数名称，用于统一注册ui事件
        this.registerWidgetEvent();

        // 固定函数名称，用于统一注册客户端事件
        this.registerEvent();
        pool.createPrefabPool(this.shopItemPrefab);
        this.shopItemArr = [];
        this.initShop();
        this.old_gold = playerData.gameData.gold;
        var self = this;
        this.countDownId = setInterval(function () {
            HttpUtil.request("user/info", {}, "GET", function (err, data) {
                if (err) {
                    cc.log(err);
                    return;
                }
                if (data.status == 200) {
                    playerData.gameData.gold = data.result.gold;
                    if (playerData.gameData.gold > self.old_gold) {
                        var diff = playerData.gameData.gold - self.old_gold;
                        self.old_gold = playerData.gameData.gold;
                        clientEvent.dispatchEvent('updateUserDataDisplay');
                        // clearInterval(this.countDownId);

                        clientEvent.dispatchEvent('showPanel', 'tipsPanel', `Receive ${diff} gold coins`);
                    }

                }
            });
        }.bind(this), 1000);
    },

    initShop() {
        this.shopArr = localConfig.getTableArr('shop');
        // 生成皮肤
        for (const shop of this.shopArr) {
            const shopItem = pool.getPrefab(this.shopItemPrefab.name);
            let script = shopItem.getComponent('shopPanelItem');
            script.show(shop, this);

            this.shopItemArr.push(shopItem);
            this.nodeShopContent.addChild(shopItem);
        }
    },

    refreshSkinData() {
        this.nodeShopContent.removeAllChildren(true);
        this.shopItemArr = [];
        this.initShop();
    },

    onBtnCloseClick() {
        if (this.countDownId) {
            clearInterval(this.countDownId);
            this.countDownId = null;
        }

        clientEvent.dispatchEvent('updateUserDataDisplay');
        clientEvent.dispatchEvent("hidePanel", "shopPanel");
    },

    onBtnRecharge() {
        var money = this.nodeMoney.getComponent(cc.EditBox).string;
        if (!money || money == undefined || money == "") {
            clientEvent.dispatchEvent('showPanel', 'tipsPanel', 'please input money');
            return;
        }

        if (cc.gameSpace.userId) {
            var url = "user_id=" + cc.gameSpace.userId + "&price=" + money + "&goodsName=" + money + "_bd";
            HttpUtil.openPay(url);
        }
    },

    onTextChanged() {
        var money = this.nodeMoney.getComponent(cc.EditBox).string;

        // 匹配整数或小数
        const regex1 = /^[1-9][0-9]*([\.][0-9]{1,2})?$/;
        if (!regex1.test(money)) {
            // clientEvent.dispatchEvent('showPanel', 'tipsPanel', 'please input number and digits');
            return
        }

        // 使用正则表达式匹配小数点后的两位小数
        var regex = /^\d+(\.\d{0,2})?$/;

        // 检查输入值是否符合要求
        if (!regex.test(money)) {
            // 如果不符合要求，截取小数点后两位小数
            money = parseFloat(money).toFixed(2);
            clientEvent.dispatchEvent('showPanel', 'tipsPanel', 'Limit input decimal points after two digits');
        }
        // 更新输入框的值
        this.nodeMoney.getComponent(cc.EditBox).string = money;
    },

    onEditingDidEnded() {
        var money = this.nodeMoney.getComponent(cc.EditBox).string;

        // 使用正则表达式匹配小数点后的两位小数
        var regex = /^\d+(\.\d{0,2})?$/;

        // 检查输入值是否符合要求
        if (!regex.test(money)) {
            // 如果不符合要求，截取小数点后两位小数
            money = parseFloat(money).toFixed(2);
        }
        // 更新输入框的值
        if (money && money > 0) {
            this.nodeMoney.getComponent(cc.EditBox).string = money;
            var goldNum = money * 100;
            this.goldLab.string = `Receive ${goldNum} gold coins`;
        } else {
            this.goldLab.string = `Receive 0 gold coins`;
            this.nodeMoney.getComponent(cc.EditBox).string = "";
        }
    },

    // 固定函数名称，用于统一注册ui事件
    registerWidgetEvent() {

    },

    // 固定函数名称，用于统一注册客户端事件
    registerEvent() {
        // 注册客户端事件的方式，在这个界面被销毁的时候，以这种方式注册的客户端事件会被自动反注册
    },

    // 界面在每次被显示的时候调用,可以传参数，非常方便的进行界面数据调试
    show(cb) {
        // 要注意调用 super,使panel中的框架代码生效
        this._super();
        if (cb) cb();
        this.shopArr = localConfig.getTableArr('shop');

        this.refreshSkinData();
    },

    update: function (c) {

    }
});

kf.addModule('shopPanel.shopPanelUIEvent', () => shopPanelObj);